import styled from 'styled-components';

export const StyledArticleCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  background-color: var(--c-surface);
  border: var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;

  .card__image {
    object-fit: cover;
    border-radius: var(--radius-sm);
    height: 180px;
    width: calc(100% + 2 * var(--space-4));
  }

  .card__title {
    order: -2;
    font-size: var(--fs-xl);
    font-weight: var(--fw-bold);
    line-height: var(--lh-tight);
  }

  .card__timestamp {
    order: -1;
    font-size: var(--fs-xs);
    color: var(--c-text-subtle);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .card__desc {
    color: var(--c-text-muted);
    font-size: var(--fs-sm);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card__link {
    margin-top: auto;
    border: var(--border);
    padding: var(--space-2);
    border-radius: var(--radius-md);
    align-self: flex-start;
    color: var(--c-accent);
    font-weight: var(--fw-bold);
    font-size: var(--fs-sm);
    transition: all 0.2s ease-in-out;
  }

  .card__link--title {
    transition: all 0.2s ease-in-out;
    border: var(--border);
    border-color: transparent;
    padding: var(--space-2);
  }

  .card__link--image {
    order: -3;
    margin: 0;
    border: var(--border);
    padding: var(--space-2);
    border-radius: var(--radius-md);
    transition: all 0.2s ease-in-out;
  }

  .card__link::after {
    content: ' →';
  }

  .card__link:hover,
  .card__link--image:hover {
    color: var(--c-accent-hover);
    border-color: var(--c-accent-hover);
    background-color: var(--c-elevated);
  }

  .card__link--title:hover {
    color: var(--c-accent-hover);
    border-color: var(--c-accent-hover);
  }

  @media (min-width: 786px) {
    .card__image {
      height: 200px;
    }
  }
`;

